import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = {
  groups: [],
  group: {},
  patients: [],
  meta: { pagination: {} },
  saving: false,
  loading: false,
  editing: false,
  patientsEdit: {
    patientIds: [],
    patientsObj: []
  }
}
let changes = null;
let groups = []
export default function groupsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}GROUPS_LOAD_PENDING`:
    case `${PARENT}GROUP_PATIENTS_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}GROUP_CREATE_PENDING`:
    case `${PARENT}GROUP_UPDATE_PENDING`:
    case `${PARENT}GROUP_DELETE_PENDING`:
      return { ...state, saving: true };

    case `${PARENT}GROUP_PATIENTS_LOAD_REJECTED`:
    case `${PARENT}GROUPS_LOAD_REJECTED`:
    case `${PARENT}GROUP_LOAD_REJECTED`:
    case `${PARENT}GROUP_CREATE_REJECTED`:
    case `${PARENT}GROUP_UPDATE_REJECTED`:
    case `${PARENT}GROUP_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false,
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}GROUPS_LOAD_FULFILLED`:
    case `${PARENT}GROUP_LOAD_FULFILLED`:
    case `${PARENT}GROUP_PATIENTS_LOAD_FULFILLED`:
      changes = {
        loading: false,
        ...response
      }
      return { ...state, ...changes };

    case `${PARENT}GROUP_CREATE_FULFILLED`:
    case `${PARENT}GROUP_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        saving: false,
        ...response
      }
      return { ...state, ...changes };

    case `${PARENT}GROUP_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      groups = [...state.groups];
      for (const [index, group] of groups.entries()) {
        if (group.id === response.group.id) {
          groups.splice(index, 1);
        }
      }
      changes = {
        groups: groups,
        saving: false,
        // ...response
      }
      return { ...state, ...changes };

    case `${PARENT}GROUP_RESET`:
      changes = {
        group: {},
      }
      return { ...state, ...changes };

    case `${PARENT}GROUP_PATIENTS_RESET`:
      changes = {
        patients: {},
      }
      return { ...state, ...changes };

    case `${PARENT}MANUAL_PATIENT_EDIT`:
      return {
        ...state,
        patientsEdit: {
          ...action.payload,
        }
      };
    default:
      return state;
  }
}